// extracted by mini-css-extract-plugin
module.exports = {"c159g22c":"c159g22c"};